import {
  PositionCatalogTable,
  PositionCatalogTableFilters,
  useDefaultHtzPositionCatalogListRequest,
} from "@/services/backend/htz/position-catalog/components/position-catalog-table";
import { NewPositionCatalogDialog } from "@/services/backend/htz/position-catalog/components/new-position-catalog-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { NavLink } from "react-router";
import { ReactNode, useCallback, useState } from "react";

export function PositionCatalogsRoute() {
  const [request, setRequest] = useState(
    useDefaultHtzPositionCatalogListRequest(),
  );

  const renderRowLink = useCallback(
    (catalogId: string, children: ReactNode) => (
      <NavLink to={catalogId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Leistungskataloge")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie Kataloge mit Vorlagen zur Definition von Positionen von HTZ Dienstleistungen verwalten.",
          )}
        </CardDescription>
        <CardAction>
          <NewPositionCatalogDialog />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <PositionCatalogTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <PositionCatalogTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
          hideBorder
        />
      </CardContent>
    </Card>
  );
}
